<script lang="ts" context="module">
	import type { LanguageCode } from '$lib/i18n/language';

	import { page } from '$app/state';
	import DeBackground from '$assets/launchpad/magazine-backgrounds/de.webp';
	import EnBackground from '$assets/launchpad/magazine-backgrounds/en.webp';
	import EsBackground from '$assets/launchpad/magazine-backgrounds/es.webp';
	import FrBackground from '$assets/launchpad/magazine-backgrounds/fr.webp';
	import ItBackground from '$assets/launchpad/magazine-backgrounds/it.webp';
	import NlBackground from '$assets/launchpad/magazine-backgrounds/nl.webp';
	import PtBackground from '$assets/launchpad/magazine-backgrounds/pt.webp';
	import Image from '$lib/components/atoms/image/Image.svelte';
	import Link from '$lib/components/atoms/link/Link.svelte';
	import { formatMagazineUrlWithTracking, magazineMediumMap, trackMagazineRedirection } from '$lib/services/tracking/googleAnalytics/magazine';
	import * as m from '$paraglide/messages';

	function handleMagazineClick() {
		trackMagazineRedirection(magazineMediumMap.launchpadRedirection);
	}

	const magazineBackgroundsMap = {
		fr: FrBackground,
		en: EnBackground,
		de: DeBackground,
		it: ItBackground,
		es: EsBackground,
		pt: PtBackground,
		nl: NlBackground,
	} satisfies Record<LanguageCode, string>;

</script>

<section data-testid="launchpad-magazine-section" class="launchpad-magazine relative flex flex-col justify-center items-center mb-8">
	<h3 class="text-center text-balance uppercase text-sm text-coloredneutral-soft font-600 my-0 mb-2 max-w-146px font-smooth">{m.launchpad__magazine_title()}</h3>
	<Image
		src={magazineBackgroundsMap[page.data?.lang]}
		alt={m.launchpad__magazine_title()}
		width="340px"
		height="172px"
		class="w-340px h-172px aspect-ratio-340/172 "
	/>
	<Link
		href={formatMagazineUrlWithTracking(magazineMediumMap.launchpadRedirection, page.data?.locale)}
		target="_blank"
		rel="external"
		button="filled"
		color="light"
		size="md"
		icon="menu-book"
		label={m.footer__magazine_button()}
		class="shadow-smooth-block mt-2 z-10"
		onclick={handleMagazineClick}
	/>
</section>

<style>
	.launchpad-magazine :global(img) {
		filter: drop-shadow(0px 4px 6px rgba(29, 49, 64, 0.05)) drop-shadow(0px 12px 16px rgba(29, 49, 64, 0.1));
	}
</style>
